import Grid from '@mui/material/Grid';
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import NewCompanyPopUp from '../NewCompanyPopUp';
import Webcam from "react-webcam";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import CheckIcon from "@mui/icons-material/Check";
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Alert from '@mui/material/Alert';

import InputAdornment from '@mui/material/InputAdornment';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { Select} from '@mui/material';
const styles = {
  root: {
    display: 'flex',
    height: 400, // Adjust as needed
    overflow: 'none',
  },
  tableWrapper: {
    width: 'calc(85vw - 150px)', // Adjust as needed
    overflowX: 'auto',
  },
  stickyCell: {
    position: 'sticky',
  left: '0px',
  width: '150px', // Adjust this to change the width of the first sticky column
  backgroundColor: '#fff', // Ensure that the sticky cells have a background to avoid content overlapping
  border: '1px solid black',
  },
  subheadingCell: {
      backgroundColor: '#f0f0f0',
      fontWeight: 'bold',
      textAlign: 'center',
    },
}
const fetchBookings = async (date) => {
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/BookingDate/${date}`);
  return response.data;
};
const EmptyMeetingRooms = () => (
  <div style={styles.emptyMeetingRooms}>
    <div style={styles.tableWrapper}>
      <TableContainer component={Paper} style={styles.blurryBackground}>
        <Table>
          {/* Random table content */}
        </Table>
      </TableContainer>
    </div>
    <div style={styles.emptyText}>
      Pilih Lokasi Meeting (Tidak ada Ruangan Meeting yang bisa dipilih)
    </div>
  </div>
);
const fetchMeetingRooms = async (event) => {
  console.log(event)
  const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/meetingRoomBasedOnLokasi`, {
    params: {
      address1: event
    }
  });
  return response.data;
};
export default function NewMailDialog({useData,searchThis,closeNewMail,check,setCheck}){
    const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [capturing, setCapturing] = useState(true);
  const webcamRef = React.useRef(null);

  const handleCapture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImageSrc(imageSrc);
    setCapturing(false);
  };

  const handleRetake = () => {
    setCapturing(true);
    setImageSrc(null);
  };

  const handleUsePhoto = () => {
    setOpen(false);
    setCapturing(true);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCapturing(true);
    setImageSrc(null);
  };

  const [nomorTandaTerima, setNomorTandaTerima] =useState();
  const [pengirim, setPengirim] =useState();
  const [selectedRooms, setSelectedRooms] = useState("Surat");
  const [selectedStorage, setSelectedStorage] = useState("Kotak Surat");
  const [storage,setStorage] = useState(["Kotak Surat", "Ruangan Management", "Meja Resepsionis", "Lemari Resepsionis"]);
  const [names,setNames] = useState(["Surat", "Paket Kecil", "Paket Besar", "Cairan", "Makanan", "Paket Sangat Besar"]);
    const [notes, setNotes] = useState();
    const [error,setError] = useState();
  const [tanggalKejadian,setTanggalKejadian] = useState(new Date())
  const [statNotify,setStatNotify] =useState("No")
  const [lokasi,setLokasi] = useState()
  const [categorias, setCategorias] = useState([]);
  const getCategorias = async () => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
    }).then(response=>{
      setCategorias(response.data.pilihanAlamat);
  });
    //console.log(res);
  }
  useEffect(() => {
      getCategorias();
      const date = new Date(); // today's date
    const formattedDate = date.toISOString().split('T')[0]; // format to YYYY-MM-DD
      
      
    fetchBookings(formattedDate).then(bookings => {
      console.log(bookings)
      const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
      setBooked(bookedCells);
    });




  }, []);
  const [unitNya,setUnitNya] =useState("");
  const changeLokasi = (event) => {
    setLokasi(event)
    setSelected(null)
    if(event==="Office Tower Eightyeight@Kasablanka"){
    }else{
    }
    fetchMeetingRooms(event).then(res => {
      if (res) {
        let roomss = res.flatMap(address => {
          return (address.RuangMeeting || []).map(room => ({
            ...room,
            location: address.LokasiSingkatan
          }));
        });
        setRooms(roomss);
      } else {
        console.error('Response is undefined: ', res);
      }
    })
    .catch(err => console.error('An error occurred while fetching meeting rooms: ', err));
  } 
    //Save Surat/Paket
    function dataURLtoBlob(dataurl) {
        if (dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type:mime});
        }
        return null;
    }

    const blob = dataURLtoBlob(imageSrc);
    const [konfirmasiBooking,setKonfirmasiBooking] = useState(false)
    const simpanSurat = () => {
      setKonfirmasiBooking(true)
    }

    const simpanBooking = () => {
      if(namaPerusahaan||namaKlien){
      const date = new Date(tanggalBooking); // today's date
      const formattedDate = date.toISOString().split('T')[0]; // format to YYYY-MM-DD
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveBookingTamu`, {
        selected, useData: {
          company: {
            namaPerushaaan: namaPerusahaan // replace with the actual company name
          },
          klien: {
            Nama: namaKlien // replace with the actual client name
          },
          sales: selectedSales,
        },
         tanggalKejadian:formattedDate, lokasi, SearchThis:"tamu"
    }).then(
    )}
    else{
      setError("belum ada Nama Klien/Nama perusahaan")
    }
    }
    //End save surat/paket
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const [selected, setSelected] = useState(null);
    const [booked, setBooked] = useState(null);


  // create an array of times
  const times = Array.from({length: 48}, (_, i) => {
    const hour = Math.floor(i/2);
    const minute = i%2 === 0 ? '00' : '30';
    const nextHour = Math.floor((i+1)/2);
    const nextMinute = (i+1)%2 === 0 ? '00' : '30';
    return `${hour.toString().padStart(2, '0')}:${minute}-${nextHour.toString().padStart(2, '0')}:${nextMinute}`;
  });

  const [rooms,setRooms]=useState([])

  const handleCellClick = (roomCode, timeIndex) => {
    const newSelection = { code: roomCode, timeIndex };
  
    const isBooked = booked?.some(booking =>
      booking.code === newSelection.code && booking.timeIndex === newSelection.timeIndex
    );
  
    if(isBooked) {
      alert("This cell is already booked");
      return;
    }
  
    setSelected(prevState => {
      const isAlreadySelected = Array.isArray(prevState) && prevState.some(selection =>
        selection.code === newSelection.code && selection.timeIndex === newSelection.timeIndex
      );
      
      if (isAlreadySelected) {

        return Array.isArray(prevState) ? prevState.filter(selection =>
          !(selection.code === newSelection.code && selection.timeIndex === newSelection.timeIndex)
        ) : [];
      } else {

        return Array.isArray(prevState) ? [...prevState, newSelection] : [newSelection];
      }
    });
};
  

  const handleButtonClick = () => {
    console.log(selected);
  };

  const [sales, setSales]= useState(["Adnan", "Diva", "Felly", "Reinner"])



  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //GetBooked Data
  

  let locationSubHeadingIndex = -1; // This is for tracking when to insert the location subheading
  const [tanggalBooking, setTanggalBooking] = useState(new Date())

  const changeTanggalBooking = (event) => {
    setTanggalBooking(event)
    const date = new Date(event); // today's date
    const formattedDate = date.toISOString().split('T')[0]; // format to YYYY-MM-DD
    
    fetchBookings(formattedDate).then(bookings => {
        console.log(bookings)
        const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
        setBooked(bookedCells);
      });
  }

  const closeKonfirmasiBooking = () => {
    setKonfirmasiBooking(false)
  }
  const [sayaMengerti, setSayaMengerti] = useState(''); 
  const [namaKlien,setNamaKlien]=useState();
  const [namaPerusahaan,setNamaPerusahaan]=useState();
  const [selectedSales, setSelectedSales] = useState([]);


    return <Grid sx={{p:2}} >
    <Dialog open={konfirmasiBooking} onClose={closeKonfirmasiBooking}>
      {selected === null && (
        <Grid sx={{p:3}}>
          <p>Belum ada jam booking yang dipilih.</p>
          <Button variant="contained" color="secondary" onClick={closeKonfirmasiBooking}>
            Close
          </Button>
        </Grid>
      )}
      {selected !== null && (
        <Grid sx={{p:3}}>
          <p>Kamu yakin mau melakukan booking ini?</p>
          <p><b>{selected ? selected.length/2 + " Jam" : ""}</b></p>
          <Alert sx={{mb:2}} severity="warning">Jangan lupa untuk <b>kenakan biaya ke klien.</b></Alert>
          <TextField
            label="Saya mengerti"
            value={sayaMengerti}
            onChange={(e) => setSayaMengerti(e.target.value)}
            helperText="Type 'saya mengerti' to proceed"
          />
          <Grid sx={12}> 
            <Button variant="contained" color="primary" onClick={simpanBooking}>
              Simpan
            </Button>
          </Grid>
        </Grid>
      )}
    </Dialog>
    <Grid container>
      <Grid xs={1}>
      <MeetingRoomIcon></MeetingRoomIcon>

      </Grid>

                          <Grid container xs={11}>
                            <Grid xs={2}>
                            Nama Klien:
                            </Grid>
                            <Grid xs={9}>
                            <TextField value={namaKlien} onChange={(event)=>setNamaKlien(event.target.value)} placeholder="Nama Klien"></TextField>
                            </Grid>
                            <Grid xs={2}>
                            Nama Perusahaan:
                            </Grid>
                            <Grid xs={9}>
                            <TextField value={namaPerusahaan} onChange={(event)=>setNamaPerusahaan(event.target.value)} placeholder="Nama Perusahaan"></TextField>
                            </Grid>
                            <Grid xs={2} sx={{mt:3}}>
                              Sales:
                            </Grid>
                            <Grid xs={9} sx={{mt:3}}>
                            <Autocomplete
                                    sx={{ width: 360 }}
                                    options={sales}
                                    freeSolo
                                    getOptionLabel={(option) => option}
                                    disableCloseOnSelect
                                    value={selectedSales}
                                    onChange={(event, newValue) => {
                                        setSelectedSales(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Pilih Sales"
                                        placeholder="Pilih Sales"
                                        />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <MenuItem
                                        {...props}
                                        key={option}
                                        value={option}
                                        sx={{ justifyContent: "space-between" }}
                                        >
                                        {option}
                                        {selected ? <CheckIcon color="info" /> : null}
                                        </MenuItem>
                                    )}
                                    />        
                            </Grid>
                          </Grid>
                          
                 
    </Grid>
    <Grid>
            
<Grid item xs={12}>
<Divider sx={{ mt: 5, mb: 2, height: 1, bgcolor: 'black' }} />
</Grid>
                  <Grid container >
                    <Grid container xs={4} sx={{mt:3}}>
                    <Grid container sx={{mt:1}} xs={3.3}>
                                    Tanggal:
                          </Grid>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={tanggalBooking}
                                    onChange={(event)=>changeTanggalBooking(event)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                                </LocalizationProvider>
                                    </Grid>
                    <Grid container xs={8}>
                          <Grid container sx={{mt:4}} xs={2}>
                                    Lokasi Sewa:
                          </Grid>
                          <Grid container xs={6} sx={{mt:3}}>
                                                  <Select value={lokasi} whiteSpace="normal" onChange={event => changeLokasi(event.target.value)}>{categorias.map((categoria) =><MenuItem multiline value={categoria}>{categoria}</MenuItem>)}</Select>                            </Grid>
                                                <Grid container sx={{mt:2}}></Grid>
                    </Grid>

                </Grid>
                <Grid item xs={12}>
<Divider sx={{ mt: 5, mb: 2, height: 1, bgcolor: 'black' }} />
</Grid>
<Grid>
<div style={styles.root}>
      {rooms.length === 0 ? (
        <EmptyMeetingRooms />
      ) : (
        <div style={styles.tableWrapper}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={styles.stickyCell}>Nama Ruangan</TableCell>
              {times.map((time, index) => (
                <TableCell key={index} style={styles.cell}>{time}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
    {rooms.flatMap((room, roomIndex) => {
        const elements = []; // This will contain the room row and possibly the location subheading

        // If it's a new location, insert a location subheading
        if (room.location !== rooms[locationSubHeadingIndex]?.location) {
            elements.push(
                <TableRow key={'loc_' + room.location}>
    <TableCell style={{...styles.locationSubheading, position: 'sticky', left: 0}}>
        {room.location}
    </TableCell>
    <TableCell colSpan={times.length} style={styles.emptyCell}>
        {/* Empty Cell */}
    </TableCell>
</TableRow>

            );
            locationSubHeadingIndex = roomIndex;
        }

        // Add the room row
        elements.push(
            <TableRow key={roomIndex}>
                <TableCell style={styles.stickyCell}>{room.name}</TableCell>
                {times.map((time, timeIndex) => {
                    const isBooked = booked?.some(booking =>
                        booking.code === room.code && booking.timeIndex === timeIndex + 1
                    );
                    const isCellSelected = selected?.some(selection =>
                        selection.code === room.code && selection.timeIndex === timeIndex + 1
                    );
                    return (
                        <TableCell
                            key={timeIndex}
                            onClick={() => handleCellClick(room.code, timeIndex + 1)} // <-- Pass room.code here
                            style={{
                              backgroundColor: isCellSelected ? 'green' : isBooked ? 'red' : 'white',
                                border: '1px solid black',
                                ...styles.cell
                            }}
                        />
                    );
                })}
            </TableRow>
        );
        return elements;
    })}
</TableBody>

        </Table>
      </TableContainer>
      </div>
      )}
    </div>
</Grid>
                

            
    </Grid>
     {error && <Grid className="error_text" sx={{mb:3, mt:3}}>{error}</Grid>}
     <Grid container>
         <Box display="flex" justifyContent="flex-end" width="100%">
             <Button sx={{mt:3}} variant="contained" onClick={()=>simpanSurat()}>Simpan</Button>
         </Box>
     </Grid>
     </Grid>
}